import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { htmlSanitizer } from '../../../lib/helpers';
import Text from '../../../shared/Text';

const SelectedAudienceHeader = ({ audienceName, description }) => (
  <AudienceInfoCard>
    <Text as="h4" variant="h5" mt="0" mb="12px">
      {audienceName}
    </Text>
    <Text as="p" m="0" dangerouslySetInnerHTML={htmlSanitizer(description)} />
  </AudienceInfoCard>
);

export default SelectedAudienceHeader;

const AudienceInfoCard = styled.div`
  background-color: ${themeGet('colors.white')};
  border: 1px solid ${themeGet('colors.black.10')};
  border-radius: 8px;
  font-family: 'Montserrat', sans-serif;
  padding: 16px;
  margin: 0 24px;
  max-width: 1100px;
`;
